export interface PromoVideo {
  embedUrl: string
  title: string
}

const ENGLISH_YOUTUBE_PROMO: PromoVideo = {
  embedUrl: 'https://www.youtube.com/embed/LsNosPbJxHk?rel=0',
  title: 'Mentiss - AI Werewolf Platform',
}

const CHINESE_YOUTUBE_PROMO: PromoVideo = {
  embedUrl: 'https://www.youtube.com/embed/L4P9Zvb_0tU?rel=0',
  title: 'Mentiss - AI 狼人杀平台',
}

const CHINESE_BILIBILI_PROMO: PromoVideo = {
  embedUrl: 'https://player.bilibili.com/player.html?bvid=BV16DpM6SETL&aid=117397830764394&cid=42531160792&autoplay=0&high_quality=1',
  title: 'Mentiss - AI 狼人杀平台',
}

export function getPromoVideo(language: string): PromoVideo {
  if (language === 'zh')
    return CHINESE_BILIBILI_PROMO
  if (language === 'tw')
    return CHINESE_YOUTUBE_PROMO
  return ENGLISH_YOUTUBE_PROMO
}
